exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.green {\n    color: #FFFFFF;\n}\n.vdp-datepicker {\n    width: 90%;\n}\n.vdp-datepicker .form-control[readonly] {\n    background-color: #fff !important;\n}\n.m_datepicker {\n    width: 165px;\n}\n.m_datepicker input {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n}\n.small_input {\n    height: 25px;\n    padding: 0 5px;\n    width: 100px;\n    margin: 0 auto;\n    font-size: 13px;\n}\ntable.inputPrice thead th{\n    min-width: 130px;\n}\ntable.inputPrice tbody td{\n}\n", ""]);

// exports
